
import axios from "axios";
import { CONFIG } from "../../../appconfig/appconfig";
import { getBranchId, getHospitalId, getLoginID, getToken } from "../../../auth";
import FetchData from "../../client";

const uploadPdfBaseURL = async (inputData) => {
    try {
      // inputData.doctorid = getLoginID();
      // inputData.type = "doctor";
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
      };
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
      const response = await axios.post(
        // `http://127.0.0.1:8000/doctor-notes-helpers/correct-cc`,
        `${CONFIG.APIBaseUrl}midoc_ai_dischargenotesgenerate`,
        inputData,
        {
          headers: headers,
        }
      );
  
      return response.data;
    } catch (error) {
      console.error("Error fetching data in forms.js:", error);
      throw error;
    }
  };
  const SaveSummaryCallLog = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_savedichargesummarylog", inputData);
      return result;
  
    } catch (error) {
      console.error('Error fetching data in forms.js:', error);
      throw error;
    }
  };
  const UploadFiletoFetchSummary = async (inputData) => {
    try {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
      };
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
      const response = await axios.post(
        // `http://127.0.0.1:8000/doctor-notes-helpers/correct-cc`,
        `${CONFIG.APIBaseUrl}midoc_ai_dischargeprocessdocuments`,
        inputData,
        {
          headers: headers,
        }
      );
  
      return response;
    } catch (error) {
      console.error("Error fetching data in forms.js:", error);
      throw error;
    }
    // try {
    //   inputData.doctorid = getLoginID();
    //   inputData.branchid = getBranchId();
    //   inputData.hospitalid = getHospitalId()
    //   const result = await FetchData("midoc_ai_dischargeprocessdocuments", inputData);
    //   return result;
  
    // } catch (error) {
    //   console.error('Error fetching data in forms.js:', error);
    //   throw error;
    // }
  };
  export {uploadPdfBaseURL,SaveSummaryCallLog, UploadFiletoFetchSummary};

